/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Card, Divider, Grid, Typography, useMediaQuery } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { BsListUl } from "react-icons/bs";

import { useLocation, useNavigate } from 'react-router-dom';

import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnBack } from 'components/Common/Button';
import { AlertTitle, AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';

import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import moment from 'moment';
import { i18n } from 'i18n';
import VerticalStepper from 'components/Stepper/VerticalStepper';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.HomeSuggestion.fields';

const HomeSuggestion = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const [sVOCFormID, setsVOCFormID] = useState(location?.state ? location.state["sVOCFormID"] : null)
    const [sDeatil, setsDeatil] = useState("-")
    const [arrDeatil, setarrDeatil] = useState([])
    const [sDate, setsDate] = useState("-")
    const [sStatus, setsStatus] = useState("-")
    const [sLastAction, setsLastAction] = useState("-")
    const [nStatusID, setnStatusID] = useState(null)


    const Layout1000 = useMediaQuery('(min-width:1000px)');

    const schema = yup.object().shape({
        sVOCForm: yupFormSchemas.string(i18n(`${i18nField}.sInvoice`), { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        //Get Data for update
        const urlParams = new URLSearchParams(location.search);
        const sParamVOCFormID = urlParams.get("strMail");
        let sParamVOCID = "";
        let IsFromMail = false;
        if((location.state && location.state["sVOCFormID"]))
        {
            sParamVOCID = location?.state["sVOCFormID"];
            setsVOCFormID(location?.state["sVOCFormID"])
            IsFromMail = false;
        }
        else if(sParamVOCFormID)
        {
            sParamVOCID = sParamVOCFormID;
            setsVOCFormID(sParamVOCFormID)
            IsFromMail = true;
        }

        //Get Data for update
        if (sParamVOCID != "") {
            setsVOCFormID(sParamVOCID)
            GetDataVOCID(sParamVOCID);
        }
    }, [location?.state])

    const GetDataVOCID = async (sParamVOCFormID) => {
        BlockUI();
        await AxiosGet(`VOC/VOCFormDataByID`, { sVOCFormID: sParamVOCFormID, "sLanguage": currentLanguage() }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {
                let Result = res?.result?.data
                if (Result != null) {
                    setnStatusID(Result.nStatusID)
                    form.setValue("sVOCForm", Result.sVOCFormCode)
                    setsDeatil( Result.sDetail ?? "-")
                    if(Result.sDetail != "" && Result.sDetail != null)
                    {
                        let message = [] = (Result.sDetail + "").split('\n')
                        setarrDeatil(message)
                    }
                    let sIssueDate = Result.dIssueDate != null ? moment(Result.dIssueDate).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : "-";
                    setsDate(sIssueDate)
                    // 
                    let sStatus = Result.sStatus ?? "-"
                    setsStatus(sStatus)
                    setsLastAction( Result.sActionLastView ?? "-")

                }

            })
        })
    }

    const onGotoBack = () => {
        let sUrl = -1 as any;
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const strMail = urlParams.get("strMail");
        
        if(strMail != null && strMail != "")
        {
            sUrl = "/Front/MyVOC";
        }
        navigate(sUrl);
    }

    return (
        <>
            <div style={{ padding: !Layout1000 ? '2em 2em 0 2em' : '6em 2em 0 2em' }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" >
                    <Grid item xs={12}>
                        <InnerHeadRoutes
                            iconMUI={<BsListUl style={{ fontSize: '1.5em' }} />}
                            labal_Head={i18n(`${i18nField}.sPetition`)}
                        />
                    </Grid>
                    <Grid item xs={12} md={10}>
                        <div
                            style={{
                                width: '100%',
                                padding: '16px',
                                borderRadius: '10px',
                                border: '1px solid #d5d5d5',
                                background:'#ffffff'
                            }}
                        >
                            <Grid container spacing={3} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item xs={12}>
                                    <Typography gutterBottom style={{ fontWeight: 500 }}>
                                    {i18n(`${i18nField}.sinformationfeedback`)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormProvider {...form}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <InputFormItem
                                                    id="sVOCForm"
                                                    name="sVOCForm"
                                                    label={i18n(`${i18nField}.sInvoice`)}
                                                    required={false}
                                                    fullWidth
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </FormProvider>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  style={{ fontWeight: 500 }}>
                                    {i18n(`${i18nField}.sFeedback`)}
                                    </Typography>
                                    {
                                        arrDeatil.length > 0 && sDeatil != null ?
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                {arrDeatil.map((m, ind) => (<p key={`note_${ind}`} style={{ margin: '0' }}>{m}</p>))} 
                                            </div>
                                            :
                                            <>
                                                <Typography >
                                                    {sDeatil}
                                                </Typography>
                                            </>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={3} md={2}>
                                            <Typography style={{ fontWeight: 500 }}>
                                            {i18n(`${i18nField}.sDate`)}
                                            </Typography>
                                            <Typography >
                                                {sDate}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={2}>
                                            <Typography style={{ fontWeight: 500 }}>
                                            {i18n(`${i18nField}.sStatus`)}
                                            </Typography>
                                            <Typography >
                                                {sStatus}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={2}>
                                            <Typography style={{ fontWeight: 500 }}>
                                            {i18n(`${i18nField}.sLastReadby`)}
                                            </Typography>
                                            <Typography >
                                                {sLastAction}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={2} >
                        <VerticalStepper sVOCFormID={sVOCFormID} />
                    </Grid>
                    <Grid item >
                        <BtnBack txt={i18n(`common.back`)} onClick={() => { onGotoBack() }} />
                    </Grid>
                </Grid>

            </div>
        </>
    )
}

export default HomeSuggestion